import React from 'react';
import Form from 'js/components/common/Form';
import { Button } from 'js/components/common/Button';
import { Input } from 'js/components/common/Fields/Input';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import * as Types from './types';

import style from './PromoCode.scss';

export const PromoCodeBare: React.FC = () => {
    const onSubmit = hooks.useOnSubmit();
    const translate = useComponentTranslations();
    const validationConfig = hooks.useValidationConfig();

    return (
        <div className={style.container}>
            <Form<Types.IPromoCodeFormValues>
                validationConfig={validationConfig}
                onSubmit={onSubmit}
                render={({ submitting, pristine, submitError, handleSubmit }) => (
                    <form
                        className={style.form}
                        onSubmit={handleSubmit}
                    >
                        {submitError && <ErrorMessage error={submitError} animate={true} />}
                        <Input
                            id="promoCode"
                            name="promoCode"
                            className={style.control}
                            label={translate('label')}
                            placeholder={translate('placeholder')}
                        />
                        <Button
                            type="submit"
                            className={style.submit}
                            disabled={submitting || pristine}
                        >
                            {translate('submit')}
                        </Button>
                    </form>
                )}
            />
        </div>
    );
};

export const PromoCode = withComponent({
    isForLoggedIn: true,
    tkPrefix: 'playtech.mobile.system.promocode.'
})(PromoCodeBare);

// <hub2-promocode></hub2-promocode>
componentService.registerWebContentComponents({ PromoCode });
